module.exports = __webpack_public_path__ + "static/media/puma-web-audio-v2.161c752f.m4a";